<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            Danh Sách Bot
        </div>
        <div class="container-tabs" v-if="maintain">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>

        <template v-else>
            <v-layout row wrap>
                <v-flex xs12>
                    <div class="card card-default">
                        <div class="card-header">
                            <h3 class="card-title">Danh sách Bot cảm xúc</h3>
                        </div>
                        <div class="card-body table-responsive">
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        outlined
                                        append-icon="search"
                                        label="Tìm kiếm"
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="desserts"
                                    :options.sync="options"
                                    :server-items-length="totalDesserts"
                                    :loading="loading"
                                    class="elevation-1"
                            >
                                <template v-slot:item.customer_facebook="{item}">
                                    <v-layout row class="customer-profile">
                                        <img :src="item.avatar" width="60">
                                        <a class="a-post-link" :href="item.customer_facebook" target="_blank">{{
                                            item.name
                                            }}</a>
                                    </v-layout>
                                </template>

                                <template v-slot:item.comment="{item}">
                                    <v-layout row>
                                        <span>{{ item.comment ? 'On' : 'Off' }}</span>
                                    </v-layout>
                                </template>

                                <template v-slot:item.settings="{item}">
                                    <v-layout row>
                                        <div class="col-12 pa-1">
                                            <v-btn depressed small color="primary" @click="openDialogExtendDate(item)">
                                                Gia hạn
                                            </v-btn>
                                            <v-btn depressed small color="purple" class="ml-2"
                                                   @click="openUpdateOrder(item)">
                                                <span class="white--text">Sửa</span>
                                            </v-btn>
                                            <v-btn depressed small color="success" class="ml-2"
                                                   @click="openDialogUpdateCookie(item)">
                                                Cookie
                                            </v-btn>
                                        </div>

                                        <div class="col-12 pa-1">
                                            <v-btn depressed small color="normal" @click="stopStartOrder(item)"
                                                   v-if="item.status_code === 1">
                                                Tạm dừng bot
                                            </v-btn>
                                            <v-btn depressed small color="normal" @click="stopStartOrder(item)"
                                                   v-if="item.status_code === 2">
                                                Bật bot
                                            </v-btn>
                                            <v-btn depressed small color="error" class="ml-2"
                                                   @click="deleteOrder(item)">
                                                Xóa
                                            </v-btn>
                                        </div>

                                    </v-layout>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-flex>
            </v-layout>

            <!--        dialog update cookie-->
            <v-dialog v-model="dialogUpdateCookie"
                      max-width="800px"
            >
                <v-card elevation="4">
                    <v-card-title>
                        <span class="headline">Cập nhật cookie</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-form
                                    ref="form_cookie"
                                    lazy-validation
                            >
                                <input type="hidden" name="token_proxy" v-model="tokenProxy" id="token_proxy">
                                <input type="hidden" name="cookie_hide" id="cookie-hide">
                                <v-textarea
                                        solo
                                        v-model="cookie"
                                        placeholder="Nhập cookie của bạn"
                                        required
                                        :rules="cookieRule"
                                ></v-textarea>
                                <v-col cols="2" class="ml-2 pt-2 extension-cookie">
                                    <v-btn class="deep-purple lighten-4" id="get-cookie-extension">
                                        Lấy cookie
                                    </v-btn>

                                    <v-btn href="/extensions/get-cookie-and-access-token" class="deep-purple lighten-4" id="update-cookie-extension">
                                        Update extension
                                    </v-btn>
                                </v-col>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"
                               text
                               @click="dialogUpdateCookie = false"
                        >
                            Close
                        </v-btn>
                        <v-btn color="blue darken-1"
                               text
                               @click="updateCookie()"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!--        dialog extend day-->
            <v-dialog v-model="dialogExtendDate"
                      max-width="800px"
            >
                <v-card elevation="4">
                    <v-card-title>
                        <span class="headline">Gia hạn bot</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-form
                                    ref="form_date_hire"
                                    lazy-validation
                            >
                                <v-flex md2>
                                    <label class="text-color">Số ngày thuê</label>
                                </v-flex>
                                <v-text-field
                                        solo
                                        v-model="dateHire"
                                        type="number"
                                        required
                                        :rules="dayHireRule"
                                        placeholder="Nhập số ngày thuê"
                                ></v-text-field>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"
                               text
                               @click="dialogExtendDate = false"
                        >
                            Close
                        </v-btn>
                        <v-btn color="blue darken-1"
                               text
                               @click="extendDate()"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!--        dialog update order-->
            <v-dialog v-model="dialogUpdateOrder"
                      max-width="1200px"
            >
                <v-card elevation="4">
                    <v-card-title>
                        <span class="headline">Cập nhật bot</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-form
                                    class="mt-3"
                                    ref="form_update_order"
                                    lazy-validation
                            >
                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Name</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-text-field
                                                solo
                                                v-model="customerName"
                                                placeholder="Tên khách hàng"
                                                disabled
                                                required
                                                :rules="customerNameRule"
                                                hide-details="auto"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Tương tác với</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-select
                                                solo
                                                :items="interactWiths"
                                                v-model="interactWith"
                                                item-text="text"
                                                item-value="value"
                                                required
                                                :rules="interactWithRule"
                                                hide-details="auto"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                    <v-flex md2>
                                        <label class="text-color">List ID User Facebook</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-checkbox
                                                v-model="listIdUser"
                                        ></v-checkbox>
                                        <v-textarea
                                                v-if="listIdUser"
                                                solo
                                                v-model="userIds"
                                                placeholder="Nhập list ID Facebook mà bạn muốn Bot chạy, mỗi ID là một dòng"
                                                required
                                                hide-details="auto"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                    <v-flex md2>
                                        <label class="text-color">List ID Page</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-checkbox
                                                v-model="listIdPage"
                                        ></v-checkbox>
                                        <v-textarea
                                                v-if="listIdPage"
                                                solo
                                                v-model="pageIds"
                                                placeholder="Nhập list ID Facebook mà bạn muốn Bot chạy, mỗi ID là một dòng"
                                                required
                                                hide-details="auto"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                    <v-flex md2>
                                        <label class="text-color">List ID Group</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-checkbox
                                                v-model="listIdGroup"
                                        ></v-checkbox>
                                        <v-textarea
                                                v-if="listIdGroup"
                                                solo
                                                v-model="groupIds"
                                                placeholder="Nhập list ID Facebook mà bạn muốn Bot chạy, mỗi ID là một dòng"
                                                required
                                                hide-details="auto"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Cảm xúc</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-select
                                                solo
                                                :items="reactions"
                                                v-model="reaction"
                                                item-text="text"
                                                item-value="value"
                                                required
                                                hide-details="auto"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Bot comment</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-radio-group v-model="offComment" class="mt-0" row hide-details="auto">
                                            <v-radio
                                                    label="Tắt"
                                                    :value="false"
                                            ></v-radio>
                                            <v-radio
                                                    label="Bật"
                                                    :value="true"
                                            ></v-radio>
                                        </v-radio-group>
                                        <small class="content-note">
                                            Tỉ lệ giữa comment và reaction là {{ this.commentPercent }}:{{ 100 -
                                            this.commentPercent }}
                                        </small>
                                    </v-flex>

                                </v-layout>

                                <v-layout row class="pa-0 mb-4" v-show="offComment">
                                    <v-flex md2>
                                        <label class="text-color">Nội dung</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-textarea
                                                name="input-7-4"
                                                solo
                                                v-model="commentList"
                                                placeholder="Lưu ý: Nếu bạn muốn chạy nhiều nội dung khác nhau thì nhập mỗi nội dung 1 dòng."
                                                required
                                                hide-details="auto"
                                        ></v-textarea>
                                        <small class="content-note">
                                            Lệnh:<br>
                                            {icon} = random emoji<br>
                                            {time} = thêm thời gian hiện tại vào comment<br>
                                            {tag:100009139678233} = tag page hoặc user vào comment, có thể tag nhiều đối
                                            tượng trong 1 comment<br>
                                            {owner}: tag tên chủ post<br>
                                            {A|B|C}: spin ngãu nhiên lựa chọn nhãn <br>
                                            Ví dụ: tôi {yêu|ghét|giận} {tag:100009139678233} từ thời điểm {time}
                                            {icon}<br>
                                            Lưu ý: Nếu bạn muốn chạy nhiều nội dung khác nhau thì nhập mỗi nội dung 1
                                            dòng.
                                        </small>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4" v-show="offComment">
                                    <v-flex md2>
                                        <label class="text-color">Comment ảnh</label>
                                    </v-flex>
                                    <v-card width="20%" height="300px">
                                        <v-card-text>
                                            <v-radio-group v-model="mediaComment" row>
                                                <v-radio
                                                        class="mb-3"
                                                        label="Upload ảnh"
                                                        value="image_upload"
                                                ></v-radio>
                                                <v-radio
                                                        class="mb-3"
                                                        label="Chọn ảnh từ hệ thống"
                                                        value="image_system"
                                                ></v-radio>
                                                <v-radio
                                                        label="Bình luận sticker"
                                                        value="sticker"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class="ml-5" width="60%" min-height="300px">
                                        <v-card-text v-if="mediaComment === 'image_upload'">
                                            <v-file-input
                                                    class="col-5 float-right"
                                                    counter
                                                    small-chips
                                                    multiple
                                                    show-size
                                                    truncate-length="10"
                                                    v-model="imageUploadComment"
                                            ></v-file-input>
                                            <v-text-field
                                                    class="col-3 float-right"
                                                    solo
                                                    v-model="imageText"
                                                    type="text"
                                                    placeholder="Chữ in trên ảnh"
                                            ></v-text-field>
                                            <small class="content-note">
                                                Lệnh:<br>
                                                {owner} = Thêm tên chủ post vào ảnh <br>
                                                Lưu ý: Lệnh {owner} khi được thêm thì các ký tự khác sẽ bị xóa
                                            </small>
                                        </v-card-text>

                                        <v-card-text v-if="mediaComment === 'sticker'">
                                            <v-select
                                                    solo
                                                    :items="stickers"
                                                    v-model="sticker"
                                                    item-text="text"
                                                    item-value="value"
                                            ></v-select>
                                            <v-card max-height="300" class="overflow-y-auto">
                                                <v-row>
                                                    <v-col cols="6"
                                                           sm="2"
                                                           v-for="img in stickerImage"
                                                           :key="img">
                                                        <v-img :height="130"
                                                               :src="img"
                                                        ></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                            <small class="content-note">
                                                Sticker sẽ được comment ngẫu nhiên trong gói được chọn
                                            </small>
                                        </v-card-text>

                                        <v-card-text v-if="mediaComment === 'image_system'">
                                            <v-select
                                                    solo
                                                    :items="imageSystemList"
                                                    v-model="imageSystemComment"
                                                    item-text="text"
                                                    item-value="value"
                                            ></v-select>
                                            <v-card max-height="300" class="overflow-y-auto">
                                                <v-row>
                                                    <v-col cols="6"
                                                           sm="2"
                                                           v-for="img in imageTheme"
                                                           :key="img">
                                                        <v-img :height="130"
                                                               :src="img"
                                                        ></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                            <v-text-field
                                                    class="col-3 float-right"
                                                    solo
                                                    v-model="imageText"
                                                    type="text"
                                                    placeholder="Chữ in trên ảnh"
                                            ></v-text-field>
                                            <small class="content-note">
                                                Lệnh:<br>
                                                {owner} = Thêm tên chủ post vào ảnh <br>
                                                Lưu ý: Lệnh {owner} khi được thêm thì các ký tự khác sẽ bị xóa,
                                                ảnh comment sẽ được random trong chủ đề được chọn
                                            </small>
                                        </v-card-text>

                                    </v-card>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Bài viết/phút</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-select
                                                solo
                                                :items="frequencies"
                                                v-model="frequency"
                                                item-text="text"
                                                item-value="value"
                                                :rules="frequencyRule"
                                                hide-details="auto"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Blacklist (không bot)</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-textarea
                                                solo
                                                v-model="blackList"
                                                placeholder="Nhập list ID Facebook mà bạn muốn Bot không chạy, mỗi ID là một dòng"
                                                required
                                                hide-details="auto"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Thời gian hoạt động</label>
                                    </v-flex>
                                    <v-flex md4>
                                        <v-select
                                                solo
                                                :items="timeStarts"
                                                v-model="timeStart"
                                                item-text="text"
                                                item-value="value"
                                                hide-details="auto"
                                        ></v-select>
                                    </v-flex>

                                    <v-flex md2 style="text-align: center;">
                                        <label class="text-color">đến</label>
                                    </v-flex>
                                    <v-flex md4>
                                        <v-select
                                                solo
                                                :items="timeEnds"
                                                v-model="timeEnd"
                                                item-text="text"
                                                item-value="value"
                                                hide-details="auto"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row class="pa-0 mb-4">
                                    <v-flex md2>
                                        <label class="text-color">Ghi chú</label>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-text-field
                                                solo
                                                v-model="note"
                                                placeholder="Thêm ghi chú người dùng (có thể để trống)"
                                                required
                                                hide-details="auto"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"
                               text
                               @click="dialogUpdateOrder = false"
                        >
                            Close
                        </v-btn>
                        <v-btn color="blue darken-1"
                               text
                               @click="updateOrder()"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-container>
</template>

<script>
  import Swal from 'sweetalert2'
  import { STATUS_BOT_ORDER } from '../../config/constant'

  import {
    BOT_INTERACTION_GET_LIST_BOT_ORDER,
    BOT_INTERACTION_EXTEND_DATE,
    BOT_INTERACTION_DELETE_ORDER,
    BOT_INTERACTION_UPDATE_COOKIE,
    BOT_INTERACTION_STOP_ORDER,
    BOT_INTERACTION_START_ORDER,
    SEEDING_TYPE_MAINTAIN,
    BOT_INTERACTION_GET_USER_FORM,
    BOT_INTERACTION_UPDATE_ORDER,
    BOT_INTERACTION_GET_IMAGE_THEME,
    BOT_INTERACTION_GET_ORDER,
    BOT_INTERACTION_GET_STICKER_IMAGE
  } from '~/store/actions.type'

  import {
    COMMON_SET_LOADING
  } from '../../store/mutations.type'
  import { SEEDING_TYPE } from '~/config/constant'
  import Vue from 'vue'
  import VueMobileDetection from 'vue-mobile-detection'
  import browserDetect from "vue-browser-detect-plugin";

  Vue.use(browserDetect);
  Vue.use(VueMobileDetection)

  export default {
    components: {
      // UserInfo,
    },
    data () {
      return {
        maintain: false,
        search: '',
        totalDesserts: 0,
        desserts: [],
        loading: true,
        dateHire: 1,
        cookie: '',
        currentOrder: {},
        tokenProxy: '',

        // dialog
        dialogUpdateCookie: false,
        dialogExtendDate: false,
        dialogUpdateOrder: false,

        options: {},
        headers: [
          { text: '#', value: 'id', align: 'center' },
          { text: 'Date', value: 'created_at', align: 'center', width: '140px' },
          { text: 'Facebook', value: 'customer_facebook', align: 'center', width: '100px' },
          { text: 'Reaction', value: 'reaction', align: 'center' },
          { text: 'Comment', value: 'comment', align: 'center' },
          { text: 'Ngày hết hạn', value: 'expired_at', width: '140px' },
          { text: 'Proxy', value: 'proxy', align: 'center' },
          { text: 'Note', value: 'note', align: 'center' },
          { text: 'Time', value: 'time_range', align: 'center', width: '100px' },
          { text: 'Thành công/Tổng post', value: 'post_run', align: 'center' },
          { text: 'Status', value: 'status', align: 'center' },
          { text: 'Status Cookie', value: 'status_cookie', align: 'center' },
          { text: 'Settings', value: 'settings', align: 'center', width: '370px' },
        ],

        // rule
        cookieRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],

        dayHireRule: [
          v => !!v || 'Trường này là bắt buộc',
          v => v >= 1 || 'Bạn phải gia hạn ít nhất 1 ngày',
        ],

        // FORM Update order
        customerName: '',

        // proxies
        proxies: [],
        proxy: 0,

        // interactWiths
        interactWiths: [
          { value: 1, text: 'Chỉ bài viết của bạn bè' },
          { value: 2, text: 'Tất cả bài viết trên newfeed' },
          { value: 3, text: 'Tương tác theo list ID (Chạy bằng Cookie)' },
        ],
        interactWith: 1,

        // userIds
        userIds: '',
        userIdsArray: [],
        listIdUser: false,

        // pageIds
        pageIds: '',
        pageIdsArray: [],
        listIdPage: false,

        // groupIds
        groupIds: '',
        groupIdsArray: [],
        listIdGroup: false,

        // reactions
        reactions: [],
        reaction: 0,

        // offComment
        offComment: false,

        // frequencies
        frequencies: [],
        frequency: 1,

        // blackList
        blackList: '',
        blackListArray: [],

        // timeStarts
        timeStarts: [
          { value: 0, text: '0 giờ' },
          { value: 1, text: '1 giờ' },
          { value: 2, text: '2 giờ' },
          { value: 3, text: '3 giờ' },
          { value: 4, text: '4 giờ' },
          { value: 5, text: '5 giờ' },
          { value: 6, text: '6 giờ' },
          { value: 7, text: '7 giờ' },
          { value: 8, text: '8 giờ' },
          { value: 9, text: '9 giờ' },
          { value: 10, text: '10 giờ' },
          { value: 11, text: '11 giờ' },
          { value: 12, text: '12 giờ' },
          { value: 13, text: '13 giờ' },
          { value: 14, text: '14 giờ' },
          { value: 15, text: '15 giờ' },
          { value: 16, text: '16 giờ' },
          { value: 17, text: '17 giờ' },
          { value: 18, text: '18 giờ' },
          { value: 19, text: '19 giờ' },
          { value: 20, text: '20 giờ' },
          { value: 21, text: '21 giờ' },
          { value: 22, text: '22 giờ' },
          { value: 23, text: '23 giờ' },
        ],
        timeStart: 6,

        // timeEnds
        timeEnds: [
          { value: 0, text: '0 giờ' },
          { value: 1, text: '1 giờ' },
          { value: 2, text: '2 giờ' },
          { value: 3, text: '3 giờ' },
          { value: 4, text: '4 giờ' },
          { value: 5, text: '5 giờ' },
          { value: 6, text: '6 giờ' },
          { value: 7, text: '7 giờ' },
          { value: 8, text: '8 giờ' },
          { value: 9, text: '9 giờ' },
          { value: 10, text: '10 giờ' },
          { value: 11, text: '11 giờ' },
          { value: 12, text: '12 giờ' },
          { value: 13, text: '13 giờ' },
          { value: 14, text: '14 giờ' },
          { value: 15, text: '15 giờ' },
          { value: 16, text: '16 giờ' },
          { value: 17, text: '17 giờ' },
          { value: 18, text: '18 giờ' },
          { value: 19, text: '19 giờ' },
          { value: 20, text: '20 giờ' },
          { value: 21, text: '21 giờ' },
          { value: 22, text: '22 giờ' },
          { value: 23, text: '23 giờ' },
        ],

        // comment
        mediaComment: 'image_upload',
        commentList: '',
        commentListArray: [],
        topComment: false,

        // sticker
        stickers: [],
        sticker: '',
        stickerImage: [],

        imageUploadComment: [],
        imageSystemList: [{ value: 0, text: 'Chọn tất cả các chủ đề' }],
        imageSystemComment: '',

        imageTheme: [],

        timeEnd: 22,

        // noDay
        noDay: 10,

        // note
        note: '',

        // image text
        imageText: '',

        // rules
        valid: true,

        commentPercent: 0,

        tokenCookieRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        customerNameRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        proxyRule: [
          // v => !!v || 'Trường này là bắt buộc',
        ],
        interactWithRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        imageCommentRule: [
          // value => !value || value.size < 2000000 || 'Ảnh upload không quá 2MB',
        ],
        frequencyRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        noDayRule: [
          v => !!v || 'Trường này là bắt buộc',
          v => v >= 1 || 'Ngày thuê ít nhât 1 ngày',
        ]

      }
    },

    computed: {
      currentUser () {
        return JSON.parse(localStorage.getItem('currentUser'))
      }
    },

    created () {
      this.checkMaintain()
      this.customDataFromApi()
      this.getImageTheme()
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.desserts = data.items
              this.totalDesserts = data.total
            })
        },
        deep: true,
      },

      search () {
        this.options.page = 1
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total
          })
      },

      userIds () {
        this.userIdsArray = this.userIds.match(/[^\r\n]+/g)
      },

      groupIds () {
        this.groupIdsArray = this.groupIds.match(/[^\r\n]+/g)
      },

      pageIds () {
        this.pageIdsArray = this.pageIds.match(/[^\r\n]+/g)
      },

      blackList () {
        this.blackListArray = this.blackList.match(/[^\r\n]+/g)
      },

      commentList () {
        if (this.commentList.trim() !== '') {
          this.commentListArray = this.commentList.match(/[^\r\n]+/g).map(function (comment) {
            let text = this.imageText.trim().search('{owner}') > -1 ? '{owner}' : this.imageText.trim()
            return {
              'content': comment,
              'image_text': text,
              'has_image_text': text !== ''
            }
          }.bind(this))
        } else {
          this.commentListArray = []
        }
      },

      imageSystemComment () {
        this.getImageTheme()
      },

      sticker () {
        this.getImageSticker()
      }
    },

    mounted () {
      this.initTable()
      setInterval(() => {
        let cookie = window.$('#cookie-hide').val()
        if (cookie !== '' && this.tokenCookie !== cookie) {
          this.cookie = cookie
          window.$('#cookie-hide').val('')
        }

        if (this.$isMobile() || !this.$browserDetect.isChrome) {
          window.$('.extension-cookie').css('display', 'none')
        }
      }, 500)
    },

    methods: {
      async checkMaintain () {
        let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN)
        if (dataInfo.includes(SEEDING_TYPE.ID_BOT_INTERACTION)) {
          this.maintain = true
        }
      },

      initTable () {
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total
          })
      },

      async customDataFromApi () {
        this.$store.commit(COMMON_SET_LOADING, true)
        let data = await this.$store.dispatch(BOT_INTERACTION_GET_USER_FORM)

        this.reactions = data.reactions
        this.reaction = data['reactions'][0].value

        this.interactWiths = data['interaction_withs']
        this.interactWith = data['interaction_withs'][0].value

        this.proxies = data.proxies

        this.stickers = data['sticker_pack']
        this.sticker = this.stickers[0].value

        this.imageSystemList = data['image_pack']
        this.imageSystemList[0].text = 'Chọn tất cả các chủ đề'
        this.imageSystemComment = this.imageSystemList[0].value

        this.frequencies = data.frequencies
        this.frequency = this.frequencies[0].value

        this.commentPercent = data['comment_percent']

        this.$store.commit(COMMON_SET_LOADING, false)
      },

      async getDataFromApi () {
        this.loading = true

        const { sortBy, sortDesc, page } = this.options

        let pageNumber = page.page || this.options.page
        let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage
        let data = await this.$store.dispatch(BOT_INTERACTION_GET_LIST_BOT_ORDER, {
          'search': this.search,
          'page': pageNumber,
          'rowsPerPage': rowsPerPage
        })
        let items = data.orders
        const total = data.total

        if (sortBy.length === 1 && sortDesc.length === 1) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy[0]]
            const sortB = b[sortBy[0]]

            if (sortDesc[0]) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }
        this.loading = false
        return { items, total }
      },

      async extendDate () {
        if (this.$refs['form_date_hire'].validate()) {
          this.$store.commit(COMMON_SET_LOADING, true)
          let status = await this.$store.dispatch(BOT_INTERACTION_EXTEND_DATE, {
            'id': this.currentOrder.id,
            'date_hire': this.dateHire
          })

          this.$store.commit(COMMON_SET_LOADING, false)
          if (status) {
            this.dialogExtendDate = false
            this.initTable()
          }
        }
      },

      async updateCookie () {
        if (this.$refs['form_cookie'].validate()) {
          this.$store.commit(COMMON_SET_LOADING, true)

          let status = await this.$store.dispatch(BOT_INTERACTION_UPDATE_COOKIE, {
            'id': this.currentOrder.id,
            'cookie': this.cookie
          })
          this.$store.commit(COMMON_SET_LOADING, false)
          if (status) {
            this.dialogUpdateCookie = false
            this.cookie = ''
            this.initTable()
          }
        }
      },

      stopStartOrder (order) {
        let message = ''
        let action = ''
        if (order.status_code === STATUS_BOT_ORDER.ACTIVE) {
          message = 'Bạn có chắc chắn muốn tạm dừng bot '
          action = BOT_INTERACTION_STOP_ORDER
        } else {
          message = 'Bạn có chắc chắn muốn kích hoạt bot '
          action = BOT_INTERACTION_START_ORDER
        }

        Swal.fire({
          title: 'Xác nhận',
          text: message,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Đồng ý!',
          cancelButtonText: 'Không'
        }).then(async (result) => {
          if (result.value) {
            if (result.value) {
              this.overlay = true
              this.$store.commit(COMMON_SET_LOADING, true)
              await this.$store.dispatch(action, {
                'id': order.id
              }).then(() => {
                this.$store.commit(COMMON_SET_LOADING, false)
                this.initTable()
              })
            }
          }
        })
      },

      async deleteOrder (order) {
        Swal.fire({
          title: 'Xác nhận',
          text: 'Bạn có chắc chắn muốn xóa bot ',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Đồng ý!',
          cancelButtonText: 'Không'
        }).then(async (result) => {
          if (result.value) {
            this.overlay = true
            this.$store.commit(COMMON_SET_LOADING, true)
            await this.$store.dispatch(BOT_INTERACTION_DELETE_ORDER, {
              'id': order.id
            }).then(() => {
              this.$store.commit(COMMON_SET_LOADING, false)
              this.initTable()
            })
          }
        })
      },

      validateForm () {
        let check = this.$refs.form_update_order.validate()
        let message = 'Thông tin điền đang chưa chính xác'
        if (this.offComment && !this.commentListArray.length) {
          check = false
          message += '<br> Nội dung bình luận không được để trống '
        }

        if (this.interactWith === 3) {
          if (this.listIdUser && !this.userIdsArray.length) {
            check = false
            message += '<br> List id user không được để trống'
          }

          if (this.listIdGroup && !this.groupIdsArray.length) {
            check = false
            message += '<br> List id group không được để trống'
          }

          if (this.listIdPage && !this.pageIdsArray.length) {
            check = false
            message += '<br> List id page không được để trống'
          }
        }

        if (this.timeStart > this.timeEnd) {
          check = false
          message += '<br> Thời gian hoạt động sau phải lớn hơn trước'
        }

        if (this.timeStart > this.timeEnd) {
          check = false
          message += '<br> Thời gian hoạt động sau phải lớn hơn trước'
        }

        return { check: check, message: message }
      },

      getParams () {
        let formData = new FormData()

        if (!this.offComment) {
          this.commentListArray = []
          this.sticker = ''
          this.topComment = false
          this.imageUploadComment = []
        }

        if (this.interactWith !== 3) {
          this.userIdsArray = []
          this.pageIdsArray = []
          this.groupIdsArray = []
        }

        if (this.mediaComment !== 'sticker') {
          this.sticker = ''
        }

        if (this.mediaComment === 'sticker') {
          this.imageUploadComment = []
          this.imageSystemComment = ''
        }

        formData.append('id', this.currentOrder.id)
        formData.append('interaction_id', this.interactWith)
        formData.append('user_ids', JSON.stringify(this.userIdsArray))
        formData.append('page_ids', JSON.stringify(this.pageIdsArray))
        formData.append('group_ids', JSON.stringify(this.groupIdsArray))
        formData.append('reaction_id', this.reaction)
        formData.append('comment', JSON.stringify(this.commentListArray))
        formData.append('post_per_minute', this.frequency)
        formData.append('black_ids', JSON.stringify(this.blackListArray))
        formData.append('time_range', `${this.timeStart}-${this.timeEnd}`)
        formData.append('sticker', this.sticker)
        formData.append('has_image_text', this.imageText.trim() !== '')

        let text = this.imageText.trim().search('{owner}') > -1 ? '{owner}' : this.imageText.trim()
        formData.append('image_text', text)

        formData.append('comment_image_type', this.mediaComment)
        formData.append('image_pack', this.imageSystemComment)
        if (this.imageUploadComment.length) {
          for (let file of this.imageUploadComment) {
            formData.append('image_comment[]', file)
          }
        }
        return formData
      },

      async updateOrder () {
        let validateForm = this.validateForm()
        if (validateForm.check) {
          try {
            Swal.fire({
              title: 'Xác nhận',
              text: 'Bạn có chắc chắn muốn update order ',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Đồng ý!',
              cancelButtonText: 'Không'
            }).then(async (result) => {
              if (result.value) {
                this.overlay = true
                this.$store.commit(COMMON_SET_LOADING, true)
                let status = await this.$store.dispatch(BOT_INTERACTION_UPDATE_ORDER, this.getParams())
                this.$store.commit(COMMON_SET_LOADING, false)
                if (status) {
                  this.dialogUpdateOrder = false
                  this.initTable()
                }
              }
            })
          } catch (error) {
            console.log(error)
          }
        } else {
          Swal.fire(
            validateForm.message,
            '...',
            'error'
          )
        }
      },

      async getImageTheme () {
        if (this.imageSystemComment !== '') {
          this.$store.commit(COMMON_SET_LOADING, true)
          this.imageTheme = await this.$store.dispatch(BOT_INTERACTION_GET_IMAGE_THEME, { id: this.imageSystemComment })
          this.$store.commit(COMMON_SET_LOADING, false)
        }
      },

      openDialogUpdateCookie (order) {
        this.currentOrder = order
        this.tokenProxy = order.token_proxy
        this.dialogUpdateCookie = true
      },

      openDialogExtendDate (order) {
        this.currentOrder = order
        this.dialogExtendDate = true
      },

      async openUpdateOrder (order) {
        this.currentOrder = order
        this.dialogUpdateOrder = true
        let data = await this.$store.dispatch(BOT_INTERACTION_GET_ORDER, { id: this.currentOrder.id })
        this.customerName = data.customerName
        this.interactWith = data.interactWith
        this.reaction = data.reaction
        this.offComment = data.offComment
        this.commentList = data.commentList
        this.frequency = data.frequency
        this.blackList = data.blackList
        this.userIds = data.userIds
        this.pageIds = data.pageIds
        this.groupIds = data.groupIds
        this.timeStart = data.timeStart
        this.timeEnd = data.timeEnd
        this.mediaComment = data.mediaComment
        this.note = data.note
        this.sticker = data.sticker
        this.imageSystemComment = data.imageSystemComment
        this.dialogUpdateOrder = true
        this.tokenProxy = this.currentOrder.token_proxy
      },

      async getImageSticker () {
        if (this.sticker !== '') {
          this.$store.commit(COMMON_SET_LOADING, true)
          this.stickerImage = await this.$store.dispatch(BOT_INTERACTION_GET_STICKER_IMAGE, { id: this.sticker })
          this.$store.commit(COMMON_SET_LOADING, false)
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
    @import "../../scss/main";

    .v-content .v-content__wrap {
        background-color: #f4f6f9;
    }

    //UserInfo
    .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
        margin-bottom: .5rem;
        font-family: inherit;
        font-weight: 400;
        line-height: 1.2;
        color: inherit;
    }

    .flex {
        padding-right: 7.5px !important;
        padding-left: 7.5px !important;
    }

    .mb-3,
    .my-3 {
        margin-bottom: 1rem !important;
    }

    .list-group {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-left: 0 !important;
        margin-bottom: 0;
    }

    .list-group-unbordered > .list-group-item {
        border-left: 0;
        border-radius: 0;
        border-right: 0;
        padding-left: 0;
        padding-right: 0;
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: .75rem 1.25rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, .125);
    }

    .v-application .float-right {
        float: right !important;
        color: inherit;
        font-size: 15px;
        margin-top: 2px;
    }

    .btn-block {
        display: block;
        width: 100%;
    }

    .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .btn-primary {
        color: #fff !important;
        background-color: #007bff;
        border-color: #007bff;
        box-shadow: none;
        text-decoration: none;
    }


    .card {
        box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
        margin-bottom: 1rem;
        min-width: 0;
        background-color: #fff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, .125);
        border-radius: .25rem;
    }

    .card-primary.card-outline {
        border-top: 3px solid #007bff;
    }

    .profile-user-img {
        border-radius: 50%;
        border: 3px solid #adb5bd;
        margin: 0 auto;
        padding: 3px;
        width: 100px;
        vertical-align: middle;
        max-width: 100%;
        height: auto;
    }

    .profile-username {
        font-size: 21px;
        margin-top: 5px;
    }

    .text-muted {
        color: #6c757d !important;
    }

    i.mdi-currency-usd {
        font-size: 20px;
        margin-right: -5px;
    }

    i.mdi-currency-usd:before {
        font-weight: bold;
    }

    //card right
    .card-title i.mdi {
        font-size: 20px;
    }

    .card-header {
        background-color: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, .125);
        padding: .75rem 1.25rem;
        position: relative;
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
        height: 50px;
    }

    .card-title {
        float: left;
        font-size: 1.1rem;
        font-weight: 400;
        margin: 0;
    }

    .card-body {
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    .text-color {
        color: #000;
    }

    .v-text-field__details {
        display: none;
    }

    button.payment {
        height: 50px;
        width: 100%;
        background-color: rgb(0, 123, 255);
        padding: .5rem 1rem;
        line-height: 1.5;
        border-radius: .3rem;
        font-weight: 400;
        font-size: 1.1rem !important;
    }

    form.v-form {
        margin-bottom: 2rem;
    }


    .buy-ip {
        .div-total {
            width: 100%;
            color: #000;
            text-align: center;

            h5 {
                font-size: 1.2rem;
                margin-bottom: 0.5rem;
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
            }

            h6 {
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
                font-size: 0.9rem;
            }

            .font-weight-bold {
                font-weight: 700 !important;
            }

            .text-primary {
                color: #007bff !important;
            }

            .small, small {
                font-size: 80%;
                font-weight: 400;
            }

            .mb-0, .my-0 {
                margin-bottom: 0 !important;
            }
        }
    }

    .v-data-table table {
        border-top: thin solid rgba(0, 0, 0, 0.12);

        tbody tr td:not(.v-data-table__mobile-row),
        thead tr th:not(.v-data-table__mobile-row) {
            border-right: thin solid rgba(0, 0, 0, 0.12);

        }

        thead tr th {
            color: #000 !important;
            padding: .75rem;
            font-size: 15px;
            vertical-align: top;
        }
    }

    .customer-profile {
        padding: 10px;
    }

    .customer-profile a {
        margin-top: 20px;
    }

    .customer-profile img {
        border-radius: 50px;
    }

    #get-cookie-extension {
        display: none;
    }
</style>
